<div class="message-card p-3" [class]="type">
  <span class="subtitle-1">{{ message }}</span>
  <lib-elux-icon [icon]="'Close.svg'" size="24" sizeType="px" (click)="onCloseClick()" />
</div>
